import { useState } from "react";
import { Link } from "react-router-dom";
import { newsletters } from "../services/inquiryService";
import Swal from "sweetalert2";
import { FaFacebook, FaGlobe, FaLinkedin } from "react-icons/fa";

export default function Footer() {
  const [email, setEmail] = useState("");

  // const handleSend = async () => {
  //   const res = await newsletters()
  //   console.log(res);
  //   debugger
  // };

  const showMessage = (msg = "", type = "success") => {
    const toast = Swal.mixin({
      toast: true,
      position: "top-right",
      showConfirmButton: false,
      timer: 3000,
    });
    toast.fire({ icon: type, title: msg });
  };
  const handleSend = async () => {
    try {
      if (!email) {
        showMessage("Enter email", "warning");
        return;
      }

      const payload = {
        email: email,
      };

      const res = await newsletters(payload);

      if (res.data.success) {
        showMessage(res.data.message, "success");
      } else {
        showMessage(res.data.message, "error");
      }
      console.log(res);
      setEmail("");
    } catch (error) {
      showMessage("The email has already send", "error");
    }
  };
  return (
    <footer className="bg-[#CAE4C9] text-black">
      {/* Top */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 items-start text-black">
          {/* About */}

          <div>
            <div className="">
              <Link to="//" className="inline-block">
                <img
                  src={`${process.env.PUBLIC_URL}/img/logo/logo3-removebg-preview.png`}
                  alt="Safira"
                  className="w-[180px] h-auto object-contain mb-2"
                />
              </Link>
            </div>
            <p className="text-sm leading-relaxed text-gray-700">
              813, Sattva Square, 150 Feet Ring Rd,
            </p>
            <p className="text-sm leading-relaxed  text-gray-700">
              opp. Twin Star,{" "}
            </p>
            <p className="text-sm leading-relaxed  text-gray-700">
              Besides RK Supreme,
            </p>
            <p className="text-sm leading-relaxed mb-4 text-gray-700">
              Nana Mava, Rajkot, Gujarat 360005
            </p>

            <p className="text-sm mb-2">
              <span className="text-black font-medium">Email:</span>{" "}
              <a
                href="mailto:contact@ambikaglobal.in"
                className="text-gray-700 hover:text-black"
              >
                contact@ambikaglobal.in
              </a>
            </p>
            <p className="text-sm mb-2">
              <span className="text-black font-medium">Sales:</span>{" "}
              <a
                href="mailto:sales@ambikaglobal.in"
                className="text-gray-700 hover:text-black"
              >
                sales@ambikaglobal.in
              </a>
            </p>
            <p className="text-sm mb-2">
              <span className="text-black font-medium">Feedback:</span>{" "}
              <a
                href="mailto:feedback@ambikaglobal.in"
                className="text-gray-700 hover:text-black"
              >
                feedback@ambikaglobal.in
              </a>
            </p>
            <p className="text-sm">
              <span className="text-black font-medium">Call us:</span>{" "}
              <a
                href="tel:0823456789"
                className="text-gray-700 hover:text-black"
              >
                +91 8999718146
              </a>
            </p>
          </div>

          {/* Information — centered */}
          <div className="flex md:justify-center justify-start text-black">
            <div>
              <h3 className="text-black font-semibold text-sm uppercase tracking-wider mb-4 pb-2 border-b border-gray-500">
                Visit Us
              </h3>
              <ul className="space-y-1">
                {[
                  "Business Hours",
                  "Monday to Saturday",
                  "10:00 AM to 08:00 PM",
                  "Sunday : Closed",
                ].map((item) => (
                  <li key={item}>
                    <Link
                      to={
                        item === "About Us"
                          ? "/about"
                          : item === "Contact Us"
                            ? "/contact"
                            : "#"
                      }
                      className="text-sm text-gray-700 hover:text-black transition-colors"
                    >
                      {item}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="flex md:justify-center justify-start">
            <div>
              <h3 className="text-black font-semibold text-sm uppercase tracking-wider mb-4 pb-2 border-b border-gray-500">
                Information
              </h3>
              <ul className="space-y-2">
                {[
                  "About Us",
                  "Download Brochure",
                  "Privacy Policy",
                  "Terms & Conditions",
                  "Contact Us",
                ].map((item) => (
                  <li key={item}>
                    <Link
                      to={
                        item === "About Us"
                          ? "#"
                          : item === "Download Brochure"
                            ? "/Brochure"
                            : item === "Contact Us"
                              ? "/contact"
                              : "#"
                      }
                      className="text-sm text-gray-700 hover:text-black transition-colors"
                    >
                      {item}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-black font-semibold text-sm uppercase tracking-wider mb-4 pb-2 border-b border-gray-500">
              Sign up newsletter
            </h3>
            <p className="text-sm text-gray-700 mb-4">
              Get updates by subscribe our weekly newsletter
            </p>
            <div className="flex">
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 px-3 py-2 text-sm bg-white border border-gray-400 text-black outline-none placeholder:text-gray-500 focus:border-black"
              />
              <button
                onClick={handleSend}
                className="bg-[#004B3D] border-black text-white px-4 py-2 text-sm font-medium transition-colors"
              >
                Subscribe
              </button>
            </div>
            <div className="flex items-center gap-3 mt-4">
              {[
                {
                  icon: FaFacebook,
                  url: "https://www.facebook.com/people/Shree-Ambika-Global/61591070396765/ ",
                },
                {
                  icon: FaLinkedin,
                  url: "https://www.linkedin.com/in/nalin-bhalara-15b5213a8/ ",
                },
                { icon: FaGlobe, url: "https://ambikaglobal.linker.store/" }, // Using FaGlobe as a placeholder for Global Linker
              ].map((social, i) => (
                <a
                  key={i}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#004B3D] hover:text-primary text-2xl"
                >
                  <social.icon />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-gray-400">
        <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-700">
            Copyright © 2026{" "}
            <Link to="/" className="text-[#004B3D] font-bold hover:underline">
              Shree Ambika Global
            </Link>
          </p>
          {/* <div className="flex items-center gap-2">
            {[1, 2, 3, 4].map(i => (
              <a key={i} href="#">
                <img src={`/img/icon/paypal${i}.jpg`} alt={`payment ${i}`} className="h-6 object-contain" />
              </a>
            ))}
          </div> */}
        </div>
      </div>
    </footer>
  );
}
